<div class="notification-area dropdown">
  <div class="ico-notification {{customClass}}" [ngClass]="numberNotification > 0 ? 'ico-notification-active' : 'ico-notification-inactive'" (mouseover)="openDropdown('button')" (mouseout)="closeDropdown('button')">
    @if (numberNotification > 0) {
      <div class="numberNotification">
        {{handleNumberNotification()}}
      </div>
    }
  </div>
  <div
    (mouseover)="openDropdown('dropdownItem')"
    (mouseout)="closeDropdown('dropdownItem')"
    class="notifications custom-tooltip dropdown-menu Header_UserMenu_Dropdown"
    [ngbCollapse]="!isOpenNotifications">
    <div class="notificationsTitle">
      <div class="status row">
        <div class="col-sm-auto pending"><div>•</div><span>não lido</span></div>
        <div class="col-sm-auto solved"><div>•</div><span>lido</span></div>
      </div>
    </div>
    @if (length > 0) {
      <div class="notificationsBody">
        @for (notification of notificationQueryResult | slice: 0 : 5; track notification; let i = $index) {
          <div
            class="NotificationsList row"
            (click)="markNotificationAsRead(notification);"
            [ngClass]="getClassNotificationRow(notification)"
            >
            <div class="Lighthouse col-sm-auto">
              <div [ngClass]="notification.notificationStatusTypeId == 1  ? 'red' : 'turquoise'">•</div>
            </div>
            <div
              id="notificationDescription{{i}}"
              class="linetext col color-text">
              <p class="gray">{{ notification.registrationDate | date: "HH:mm - dd/MM/yyyy"}}</p>
              <p class="mt-0">
                @if (notification.description.startsWith('Protocolo:')) {
                  <strong>{{ notification.description.substr(0, 9) }}</strong>{{ notification.description.substr(9) }}
                } @else {
                  {{ notification.description }}
                }
              </p>
            </div>
          </div>
        }
      </div>
    }
    @if (length == 0) {
      <div class="notificationsBody empty">
        Não há notificações
      </div>
    }
  </div>
</div>
